/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookCheck: {
  name: 'book-check';
  data: string;
} = {
  name: 'book-check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.699.6a.5.5 0 0 1 .438-.08L8 2.48 14.863.52A.5.5 0 0 1 15.5 1v12a.5.5 0 0 1-.363.48l-6.989 1.998a.5.5 0 0 1-.142.022h-.012a.5.5 0 0 1-.142-.022L.862 13.48A.5.5 0 0 1 .5 13V1A.5.5 0 0 1 .699.6ZM14.5 12.624l-6 1.714V3.377l6-1.714v10.96Zm-13-10.96 6 1.714v10.96l-6-1.714V1.663Zm11.854 5.69a.5.5 0 0 0-.708-.707L11 8.293l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
